export const boardsDescriptions = {
  BOARD: 'HaveBoards',
  BASIC_BOARD: 'HaveBoards',
  COUNCIL: 'HaveCouncils',
};
